'use strict';
import Splide from "@splidejs/splide";

window.Splide = Splide;

document.addEventListener('DOMContentLoaded', () => {
  const btnTextMore = document.querySelector('.js-text-more');
  const mainText = document.querySelector('.main-block__text');

  if(mainText && document.body.clientWidth < 768) {
    const maxRows = 5;
    const lineHeight = window.getComputedStyle(mainText).getPropertyValue('line-height');
    const maxHeight = maxRows * parseFloat(lineHeight);

    if( mainText.offsetHeight > maxHeight ) {
      btnTextMore.classList.remove('main-block__more--hidden');
      mainText.classList.remove('main-block__text--open');
    }
  }

  if(btnTextMore) {
    btnTextMore.addEventListener('click', (e) => {
      const self = e.target;
      self.classList.toggle('main-block__more--open');
      mainText.classList.toggle('main-block__text--open');

      self.innerHTML = self.closest('.main-block__more--open') ? self.getAttribute('data-hide') : self.getAttribute('data-show');
    });
  }

  // target link
  const linkTarget = document.querySelector('.main-block__button');
  const header = document.querySelector('header');

  if(linkTarget) {
    linkTarget.addEventListener('click', (e) => {
      e.preventDefault();
      const link = e.target.getAttribute('href');
      const pos = link.indexOf('#');

      if(pos !== -1) {
        const blockID = link.substring(pos);
        const elID = document.querySelector(blockID);
        const topOffset = header.offsetHeight + 24;
        const elementPosition = elID.getBoundingClientRect().top;
        const offsetPosition = elementPosition - topOffset;

        window.scrollBy({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  }

  // btn to top
  const btnToTop = document.querySelector('.btn-arrow');
  window.addEventListener('scroll', () => {
    if(window.scrollY > 300) {
      btnToTop.classList.add('btn-arrow--active');
    } else {
      btnToTop.classList.remove('btn-arrow--active');
    }
  });

  btnToTop.addEventListener('click', () => {
    document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});